const initialState = {
  dashboard: {
    isLoading: false,
    error: null,
    availableNumbers: 0,
    availableSlot: null,
    assignmentStatus: null, // Estado de asignaciones desde la API
    hasReachedMaxAssignments: false, // Bandera global: todos los tipos en 0
    hasReachedMaxCompany: false, // Bandera individual: company en 0
    hasReachedMaxBranch: false, // Bandera individual: branch en 0
    hasReachedMaxAgent: false, // Bandera individual: agent en 0
    numbers: [],
    // Estado de la conexión con Cloud API (WhatsApp Business / WABA).
    // `connected` gobierna la visibilidad de la tab de números de WABA y el
    // mensaje "no tenés un WhatsApp Business conectado" en el modal de linkeo.
    cloudApi: {
      connected: false,
      wabaId: null,
      phoneNumbers: [], // números disponibles en la WABA + registration_status
      isLoading: false,
      error: null,
      billingEligibilityIssue: {
        isActive: false,
        details: null,
        dismissed: false,
      },
    },
    // Modal para agregar número
    addNumberModal: {
      isOpen: false,
      isLoading: false,
      step: 0,
      selectedSlot: null, // Slot específico seleccionado desde la tabla
      lastAssignedSlot: null, // Slot recién asignado/creado para mostrar en success step
      form: {
        phoneType: 'business',
        data: null,
      },
    },
    // Modal para vincular WhatsApp
    linkWhatsAppModal: {
      isOpen: false,
      selectedNumber: null,
      qrCode: null,
      isLoadingQR: false,
      qrError: null,
      isLinkedSuccessfully: false, // Flag para indicar vinculación exitosa
      linkedPhoneNumber: null, // Número recién vinculado del WebSocket
      currentStep: 'info', // 'info' | 'qr' | 'success' | 'error'
      isConfirmed: false, // Estado de confirmación del checkbox
      duplicatePhoneError: null, // { phoneNumber: string } cuando hay error de número duplicado
    },
    // Modal de confirmación para vincular una cuenta a Cloud API (Embedded Signup)
    linkCloudApiAccountModal: {
      isOpen: false,
    },
    // Modal de confirmación para desvincular (unlink) la cuenta de Cloud API
    unlinkCloudApiAccountModal: {
      isOpen: false,
    },
    // Estado global de conexiones WebSocket
    webSocketState: {
      activeConnection: null, // 'chat' | 'dashboard' | null
      chatConnectionActive: false,
      dashboardConnectionActive: false,
      preferredConnection: 'chat', // Prioridad por defecto
    },
    // Filtros y paginación
    filters: {
      search: '',
      status: 'all', // 'all', 'linked', 'not_linked'
    },
    pagination: {
      page: 1,
      pageSize: 10,
      totalItems: 0,
    },
  },
};

export default initialState;
